import { checkInputSupport, checkMobileOperatingSystem, getMobileOperatingSystem, } from '@anwb/browser';
export const preferNativeDatepicker = () => {
    return (checkMobileOperatingSystem() &&
        getMobileOperatingSystem() !== 'android' &&
        checkInputSupport('date'));
};
//# sourceMappingURL=prefer-native-datepicker.js.map